import {useGuideFlowProviderContext} from "../../../../../GuideFlowProviderContext";
import {Controller, useForm} from "react-hook-form";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Field, Label} from "../../../../controls/tailwindui/fieldset";
import {Button} from "../../../../controls/tailwindui/button";
import {CassieAwareSubmitButton} from "../../../../controls/vidence/cassie/CassieAwareSubmitButton";
import {CassieOfflineBanner} from "../../../../controls/vidence/cassie/CassieOfflineBanner";
import {ContactProgressionEventForm} from "./FormTypes";
import LocationSelector from "../../../../controls/gf/LocationSelector";
import {ContactProgressionEvent} from "../../../../../providers/contact/ContactProgressionEventProvider";
import toast from "react-hot-toast";
import {SECTION_ROOT} from "../../FormTypes";
import {dateTextToUtcSeconds, utcSecondsToDateText} from "../../../../../helpers/Dates";
import InitiationSelector from "../../../../controls/gf/InitiationSelector";
import {InitiationDefinition} from "../../../../../providers/definitions/InitiationDefinitionProvider";
import {LocationDefinition} from "../../../../../providers/definitions/LocationDefinitionProvider";

export default function ContactProgressionAddEditInitiation() {

    const {id, progressionId} = useParams();
    const context = useGuideFlowProviderContext();
    const {control, reset, register, handleSubmit} = useForm<ContactProgressionEventForm>();
    const [isSaving, setIsSaving] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (progressionId) {
            context.Contacts.ProgressionEvents.get(progressionId).then(evnt => {
                context.InitiationDefinitions.getList([evnt.definitionId]).then(list => {
                    reset({
                        definition: list,
                        eventDate: utcSecondsToDateText(evnt.eventDateUtcSeconds),
                        ...evnt,
                    });
                });
            });
        }
    }, [progressionId, id, reset, context.Contacts.ProgressionEvents, context.Contacts.ProgressionEvents.StateChanged, context.InitiationDefinitions, context.InitiationDefinitions.StateChanged]);

    const handleLocationChange = (value: LocationDefinition, field: any) => {
        field.onChange(value.id);
    }

    const handleChange = (value: InitiationDefinition[], field: any) => {
        field.onChange(value);
    }

    const onSubmit = async (formData: ContactProgressionEventForm) => {

        setIsSaving(true);

        const item: ContactProgressionEvent = {
            ...formData,
            contactId: id,
            eventDateUtcSeconds: dateTextToUtcSeconds(formData.eventDate),
            definitionType: "initiation",
            definitionId: formData.definition[0].id,
            locationId: formData.locationId
        };

        await context.Contacts.ProgressionEvents.save(item);
        toast.success("Initiation Added!", {icon: "🪄"});
        setIsSaving(false);
        navigate(`${SECTION_ROOT}/${id}/progression`);
    };
    const isEditMode = progressionId != null;

    return (
        <div>
            <CassieOfflineBanner/>
            <div className="p-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="xl:gap-x-16">
                        <div>
                            <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                                <div>
                                    <Field>
                                        <Label>Initiation</Label>
                                        {/*<Input {...register("", {required: true,})} invalid={errors?.title != null} autoFocus={true}/>*/}
                                        {/*{errors?.title && <ErrorMessage>*{errors.title.message}</ErrorMessage>}*/}

                                        <Controller
                                            name="definition"
                                            control={control}
                                            rules={{required: true}}
                                            defaultValue={[]}
                                            render={({field}) => (
                                                <InitiationSelector
                                                    allowMultiple={false}
                                                    readonly={isEditMode}
                                                    selection={field.value?.map(v => v as InitiationDefinition) ?? []}
                                                    onSaveSelection={(value) => handleChange(value, field)}
                                                />
                                            )}
                                        />
                                    </Field>
                                </div>
                                <div className="sm:col-span-2">
                                    <Field>
                                        <Label>Location</Label>
                                    </Field>
                                    <Controller
                                        name="locationId"
                                        control={control}
                                        defaultValue={null}
                                        render={({field, fieldState, formState,}) => (
                                            <LocationSelector selectedLocationId={field.value}
                                                              onSaveSelection={(value) => handleLocationChange(value, field)}/>)}
                                    />
                                </div>
                                <div className="sm:col-span-2">
                                    <Field>
                                        <Label>Date/Time</Label>
                                    </Field>
                                    <input aria-label="Date and time" {...register("eventDate", {required: true})} type="date"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 flex items-center justify-end gap-x-6">
                        <Button type="button" disabled={isSaving} onClick={() => navigate("../")} outline={true}>
                            Cancel
                        </Button>
                        <CassieAwareSubmitButton isSaving={isSaving}/>
                    </div>
                </form>
            </div>
        </div>
    )
}